<template>
    <div class="w-lg-500px bg-white rounded shadow-sm mt-0 p-10 p-15 mx-auto text-center">
        <div class="text-center">
            <h1 class="text-primary mb-7">{{ $t('pages.instructor.selfLogin.title') }}</h1>

            <div class="text-gray-600 fw-bold fs-7">
                {{ $t('pages.instructor.selfLogin.description') }}
            </div>
        </div>
    </div>
</template>
<route>
{
    "meta": {
        "without_middleware": ["auth"]
    }
}
</route>
<script>
import {Actions} from "@/store/enum/StoreEnums";

export default {
    name: "index",
    layout: "auth",
    created() {
        this.selfLogin();
    },
    methods: {
        selfLogin(){
            this.$store.dispatch(Actions.CHECK_SELF_LOGIN, {
                token: this.urlParams('token'),
                tokenType: this.urlParams('tokenType')
            }).then((response) => {
                if(response.status) {
                    this.$root.verifyAuth(() => { this.$router.push({ name: "dashboard" }) });
                } else {
                    this.$router.push({ name: "login" })
                }
            });
        }
    }
}
</script>

<style scoped>

</style>